module.exports = __webpack_public_path__ + "assets/icons/logo-temis-3a0e.svg";